// extracted by mini-css-extract-plugin
export default {"title":"Areas_title__9xoM9","area":"Areas_area__j4Nlk","message":"Areas_message__HEpYE"};